import React from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../Common/Header';
import { SecondNav } from '../Common/SecondNav';
import Profile from '../../Models/Profile';
import { Footer } from '../Common';
var striptags = require('striptags');
class ProfileView extends React.Component {
    constructor(props) {
        super(props);
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);

        this.state = {
            minHeight: "475px",
            modalIsOpen: false,
            user: logged_user,
            profession: '',
            photo_id: null,
            utility: null,
            services: [],
            portfolio: [],
            area: '',
            address: '',
            x: '',
            profile_picture: null,
            profile: [],
            personal: [],
            intro: ''
        };
    }

    componentDidMount() {
        if (this.props.match.params.id) {
            Profile.getServiceList(this.props.match.params.id).then(res => {
                if (res.data.payload != null) {
                    this.setState({ services: res.data.payload })
                }
            })
            Profile.getPortfolio(this.props.match.params.id).then(res => {
                if (res.data.payload != null) {
                    this.setState({ portfolio: res.data.payload })
                }
            })
            Profile.getProfile(this.props.match.params.id).then(res => {
                if (res.data.profile != null) {
                    this.setState({ profile: res.data.profile })
                    this.setState({ address: res.data.profile.address })
                    this.setState({ personal: res.data.personal })
                    this.setState({ intro: res.data.personal.personal_details })
                }
            })
        } else {
            Profile.getServiceList(this.state.user.id).then(res => {
                if (res.data.payload != null) {
                    this.setState({ services: res.data.payload })
                }
            })
            Profile.getPortfolio(this.state.user.id).then(res => {
                if (res.data.payload != null) {
                    this.setState({ portfolio: res.data.payload })
                }
            })
            Profile.getProfile(this.state.user.id).then(res => {
                if (res.data.profile != null) {
                    this.setState({ profile: res.data.profile })
                    this.setState({ address: res.data.profile.address })
                    this.setState({ personal: res.data.personal })
                }
            })
        }


        // Profile.getBasics(this.state.user.id).then(res => {
        //     if (res.data.payloads != null) {
        //         this.setState({ profile: res.data.payloads })
        //         this.setState({ profession: res.data.payloads.profession })
        //         this.setState({ photo_id: res.data.payloads.pid })
        //         this.setState({ profile_picture: res.data.payloads.img })
        //         this.setState({ utility: res.data.payloads.ut })
        //         this.setState({ x: res.data.payloads.sex })
        //         this.setState({ area: res.data.payloads.residential_area })
        //         this.setState({ address: res.data.payloads.address })
        //     }
        // })
    }
    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div>
                    <div className="container-fluid">
                        <div className="col-md-12" >
                            <div className="">
                                <Header />
                            </div>
                        </div>
                        <div className="mt-5 ml-5">&nbsp;</div>
                        <div className="mt-4 ml-5">&nbsp;</div>
                        <div className="col-md-12" style={{ minHeight: "800px",fontSize:'13px' }}>
                            <div className="row text-center">
                                <div className="col-md-6 mt-2">
                                    <img style={{ borderRadius: "50%" }} alt="" className="profile-image-mobile" src={this.state.profile.img} height="140" width='140' style={{ objectFit: 'cover' }} />
                                </div>
                                <div style={{ paddingTop: "2%", width: "100%" }}>
                                    <h4><b><i>{this.state.personal.first_name}</i></b></h4><br />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-2"></div>
                                <div className="col-md-8" style={{ border: "1px solid #f1f0ee", padding: "4%", textAlign: "left", minHeight: "100px" }}>
                                    <div>
                                        {(() => {
                                            if (this.state.intro !== null) {
                                                return (
                                                    this.state.intro.split('\n').map((item, key) =>
                                                        <span key={key}>
                                                            {item}
                                                            <br />
                                                        </span>
                                                    )
                                                )
                                            } else {
                                                return (
                                                    <div className=""></div>
                                                )
                                            }
                                        })()}
                                    </div>
                                </div>
                                <div className="col-md-2"></div>
                            </div>
                            <div>&nbsp;</div>
                            <div className="row" >
                                <div className="col-md-2"></div>
                                <div className="col-md-8" style={{ border: "1px solid #f1f0ee", padding: "4%", textAlign: "center", minHeight: "200px" }}>
                                    <fieldset className="fieldset_border">
                                        <legend className="fieldset_legend" style={{ width: "15%", }}>職業</legend>
                                        <span><div className="pb-1"style={{ textAlign: "left" }}>{this.state.profile.profession}</div></span>
                                    </fieldset>
                                    <br />
                                    <fieldset className="fieldset_border">
                                        <legend className="fieldset_legend" style={{ width: "15%", }}>性別</legend>
                                        <span><div className="pb-1"style={{ textAlign: "left" }}>{this.state.profile.description}</div></span>
                                    </fieldset>
                                    <br />
                                    <fieldset className="fieldset_border">
                                        <legend className="fieldset_legend" style={{ width: "35%", }}>リビングエリア</legend>
                                        <span><div className="pb-1"style={{ textAlign: "left" }}>{this.state.profile.area}</div></span>
                                    </fieldset>
                                    <br />
                                    <fieldset className="fieldset_border">
                                        <legend className="fieldset_legend" style={{ width: "15%", }}>住所</legend>
                                        <span>
                                            <div className="pb-1" style={{ textAlign: "left" }}>
                                            {(() => {
                                                if (this.state.address !== null) {
                                                    return (
                                                        this.state.address.split('\n').map((item, key) =>
                                                            <span key={key}>
                                                                {item}
                                                                <br />
                                                            </span>
                                                        )
                                                    )
                                                } else {
                                                    return (
                                                        <div className=""></div>
                                                    )
                                                }
                                            })()}
                                        </div></span>
                                    </fieldset>
                                    {/* <div className="col-md-12 row">
                                        <div className="col-md-4" style={{ textAlign: "left" }}>
                                            <b><i>職業</i></b>
                                        </div>
                                        <div className="col-md-1"></div>
                                        <div className="col-md-7" style={{ textAlign: "left" }}>
                                            {this.state.profile.profession}
                                        </div>
                                    </div>
                                    <div className="col-md-12 row">
                                        <div className="col-md-4" style={{ textAlign: "left" }}>
                                            <b><i>性別</i></b>
                                        </div>
                                        <div className="col-md-1"></div>
                                        <div className="col-md-7" style={{ textAlign: "left" }}>
                                            {this.state.profile.description}
                                        </div>
                                    </div>
                                    <div className="col-md-12 row">
                                        <div className="col-md-4" style={{ textAlign: "left" }}>
                                            <b><i>都道府県選択</i></b>
                                        </div>
                                        <div className="col-md-1"></div>
                                        <div className="col-md-7" style={{ textAlign: "left" }}>
                                            {this.state.profile.area}
                                        </div>
                                    </div>
                                    <div className="col-md-12 row">
                                        <div className="col-md-4" style={{ textAlign: "left" }}>
                                            <b><i>住所</i></b>
                                        </div>
                                        <div className="col-md-1"></div>
                                        <div className="col-md-7" style={{ textAlign: "left" }}>
                                            {(() => {
                                                if (this.state.address !== null) {
                                                    return (
                                                        this.state.address.split('\n').map((item, key) =>
                                                            <span key={key}>
                                                                {item}
                                                                <br />
                                                            </span>
                                                        )
                                                    )
                                                } else {
                                                    return (
                                                        <div className=""></div>
                                                    )
                                                }
                                            })()}
                                        </div>
                                    </div> */}
                                </div>
                                <div className="col-md-2"></div>
                            </div>
                            <div className="row">&nbsp; </div>
                            <div className="row" style={{ paddingTop: "4%", paddingBottom: "4%" }}>
                                <div className="col-md-1"></div>
                                <div className="col-md-5" style={{ textAlign: "left",fontSize:'20px' }}>
                                    <div>ポートフォリオ</div>
                                </div>
                                <div className="col-md-5" style={{ textAlign: "left" }}>
                                    <Link to={{
                                        pathname: `/my-portfolio`,
                                    }}>
                                        <span className="sky-a"><b>すべて見る</b></span>
                                    </Link>
                                </div>
                                <div className="col-md-1"></div>
                            </div>
                            {(() => {
                                if (this.state.portfolio.length === 0) {
                                    return (
                                        <div></div>
                                    )
                                } else {
                                    return (
                                        <div style={{ minHeight: "100px", padding: "2%", textAlign: "center" }}>
                                            <div className="col-md-12 row" style={{ textAlign: "center" }}>
                                                {this.state.portfolio.map(group =>
                                                    <div className="col-md-3" style={{ padding: "2%" }}>
                                                        <div><img style={{ height: "200px", width: "200px" }} src={group.img}></img></div>
                                                        <div>{group.title.substring(0, 20)}...</div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )
                                }
                            })()}
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        } else if (isDesktop) {
            return (
                <div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12" >
                                <div className="">
                                    <Header />
                                </div>
                            </div>
                            <div className="mt-5 ml-5">&nbsp;</div>
                            <div className="mt-4 ml-5">&nbsp;</div>
                            <div className="container" style={{ minHeight: "800px" }}>
                                <div className="row">
                                    <div className="ml-5 mt-2">
                                        <img style={{ borderRadius: "50%" }} alt="" className="rounded-circle" src={this.state.profile.img} height="140" width='140' style={{ objectFit: 'cover' }} />
                                    </div>
                                    <div style={{ paddingLeft: "19%", paddingTop: "2%", width: "70%" }}>
                                        <h4><b><i>{this.state.personal.first_name}</i></b></h4><br />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2"></div>
                                    <div className="col-md-8" style={{ border: "1px solid #f1f0ee", padding: "4%", textAlign: "left", minHeight: "100px" }}>
                                        <div>
                                            {(() => {
                                                if (this.state.intro !== null) {
                                                    return (
                                                        this.state.intro.split('\n').map((item, key) =>
                                                            <span key={key}>
                                                                {item}
                                                                <br />
                                                            </span>
                                                        )
                                                    )
                                                } else {
                                                    return (
                                                        <div className=""></div>
                                                    )
                                                }
                                            })()}
                                        </div>
                                    </div>
                                    <div className="col-md-2"></div>
                                </div>
                                <div>&nbsp;</div>
                                <div className="row">
                                    <div className="col-md-2"></div>
                                    <div className="col-md-8" style={{ border: "1px solid #f1f0ee", padding: "4%", textAlign: "center", minHeight: "200px" }}>
                                        <div className="col-md-12 row">
                                            <div className="col-md-4" style={{ textAlign: "right" }}>
                                                <b><i>職業:</i></b>
                                            </div>
                                            <div className="col-md-1"></div>
                                            <div className="col-md-7" style={{ textAlign: "left" }}>
                                                {this.state.profile.profession}
                                            </div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-4" style={{ textAlign: "right" }}>
                                                <b><i>性別:</i></b>
                                            </div>
                                            <div className="col-md-1"></div>
                                            <div className="col-md-7" style={{ textAlign: "left" }}>
                                                {this.state.profile.description}
                                            </div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-4" style={{ textAlign: "right" }}>
                                                <b><i>都道府県選択:</i></b>
                                            </div>
                                            <div className="col-md-1"></div>
                                            <div className="col-md-7" style={{ textAlign: "left" }}>
                                                {this.state.profile.area}
                                            </div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-4" style={{ textAlign: "right" }}>
                                                <b><i>住所:</i></b>
                                            </div>
                                            <div className="col-md-1"></div>
                                            <div className="col-md-7" style={{ textAlign: "left" }}>
                                                {(() => {
                                                    if (this.state.address !== null) {
                                                        return (
                                                            this.state.address.split('\n').map((item, key) =>
                                                                <span key={key}>
                                                                    {item}
                                                                    <br />
                                                                </span>
                                                            )
                                                        )
                                                    } else {
                                                        return (
                                                            <div className=""></div>
                                                        )
                                                    }
                                                })()}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-2"></div>
                                </div>
                                {/* <div className="row" style={{ paddingTop: "4%", paddingBottom: "4%" }}>
                                <div className="col-md-1"></div>
                                <div className="col-md-5" style={{ textAlign: "left" }}>
                                    <h3>リスティングサービス</h3>
                                </div>
                                <div className="col-md-5" style={{ textAlign: "right" }}>
                                    <Link to={{
                                        pathname: `/service-list`,
                                    }}>
                                        <span className="sky-a"><b>すべて見る</b></span>
                                    </Link>
                                </div>
                                <div className="col-md-1"></div>
                            </div> */}
                                {/* {(() => {
                                if (this.state.services.length === 0) {
                                    return (
                                        <div></div>
                                    )
                                } else {
                                    return (
                                        <div style={{ minHeight: "100px", padding: "2%", textAlign: "center" }}>
                                            <div className="col-md-12 row" style={{ textAlign: "center" }}>
                                                {this.state.services.map(group =>
                                                    <div className="col-md-3" style={{ padding: "2%" }}>
                                                        <div><img style={{ height: "200px", width: "200px" }} src={group.img}></img></div>
                                                        <div>{group.title.substring(0, 20)}..</div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )
                                }
                            })()} */}
                                <div className="row">
                                    &nbsp;
                            </div>
                                <div className="row" style={{ paddingTop: "4%", paddingBottom: "4%" }}>
                                    <div className="col-md-1"></div>
                                    <div className="col-md-5" style={{ textAlign: "left" }}>
                                        <h3>ポートフォリオ</h3>
                                    </div>
                                    <div className="col-md-5" style={{ textAlign: "right" }}>
                                        <Link to={{
                                            pathname: `/my-portfolio`,
                                        }}>
                                            <span className="sky-a"><b>すべて見る</b></span>
                                        </Link>
                                    </div>
                                    <div className="col-md-1"></div>
                                </div>
                                {(() => {
                                    if (this.state.portfolio.length === 0) {
                                        return (
                                            <div></div>
                                        )
                                    } else {
                                        return (
                                            <div style={{ minHeight: "100px", padding: "2%", textAlign: "center" }}>
                                                <div className="col-md-12 row" style={{ textAlign: "center" }}>
                                                    {this.state.portfolio.map(group =>
                                                        <div className="col-md-3" style={{ padding: "2%" }}>
                                                            <div><img style={{ height: "200px", width: "200px" }} src={group.img}></img></div>
                                                            <div>{group.title.substring(0, 20)}...</div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )
                                    }
                                })()}
                            </div>
                        </div>
                    </div>
                    <div className=" mt-5" >
                        <div className=" mt-5">
                            <Footer />
                        </div>
                    </div>
                </div>
            );
        }
    }
}

// const mapStateToProps = (state) => ({
//     buyerLogin: state.buyerLogin,
// });

// BuyerLogin = connect(mapStateToProps, { buyerLogin })(BuyerLogin);

export { ProfileView };